/**
 * Component - Base class for entity components
 */

import { ComponentType } from '../types/enums';

export abstract class Component {
  abstract readonly type: ComponentType;
  protected owner: { position: { x: number; y: number; z: number } } | null = null;

  /** Attach component to entity */
  attach(owner: { position: { x: number; y: number; z: number } }): void {
    this.owner = owner;
  }

  /** Detach component from entity */
  detach(): void {
    this.owner = null;
  }

  /** Update component (called every frame) */
  abstract update(deltaTime: number): void;

  /** Get the owner entity */
  getOwner(): { position: { x: number; y: number; z: number } } | null {
    return this.owner;
  }
}
